import {
	type AccessLevel,
	PRIVATE_ACCESS_LEVEL,
	LIMITED_ACCESS_LEVEL,
	OPEN_ACCESS_LEVEL,
	FREE_ACCESS_LEVEL,
} from '@atlassian/jira-shared-types/src/project.tsx';
import { fg } from '@atlassian/jira-feature-gating';

export const transformAccessLevel = (accessLevelRaw: string): AccessLevel | undefined => {
	switch (accessLevelRaw) {
		case 'PRIVATE':
			return PRIVATE_ACCESS_LEVEL;
		case 'LIMITED':
			return LIMITED_ACCESS_LEVEL;
		case 'OPEN':
			return OPEN_ACCESS_LEVEL;
		case 'FREE':
			return fg('fix_split_share_button_sentry_error') ? FREE_ACCESS_LEVEL : undefined;
		default:
			return undefined;
	}
};
